import { useLocalStorage } from 'usehooks-ts';

import { generateShortId } from '@/lib/utils/string';
import { useBuildAccountUrl } from '@/lib/accounts/context';

import { SlackIntegrationKey } from './../utils';

const SlackClientId = import.meta.env.VITE_SLACK_CLIENT_ID ?? '3294454071765.8355925725392';
const SlackUserScopes = [
  'channels:history',
  'channels:read',
  'emoji:read',
  'files:read',
  'groups:history',
  'groups:read',
  'links:read',
  'reactions:read',
  'search:read',
  'team:read',
  'users:read',
  'users:read.email',
];
const SlackBotScopes = [
  'channels:history',
  'channels:read',
  'channels:join',
  'groups:history',
  'groups:read',
  'im:history',
  'im:read',
  'mpim:history',
  'mpim:read',
  'users:read',
  'users:read.email',
  'team:read',
  'emoji:read',
  'files:read',
  'links:read',
  'reactions:read',
  'chat:write',
  'im:write',
  'commands',
];

export const useSlackIntegration = () => {
  const buildAccountUrl = useBuildAccountUrl();

  const [, setSlackState] = useLocalStorage<string | null>(SlackIntegrationKey, null);
  const generateSlackRedirect = () => {
    const state = generateShortId(8);
    const url = new URL('/oauth/v2/authorize', 'https://slack.com');
    url.searchParams.set('scope', SlackBotScopes.join(','));
    url.searchParams.set('user_scope', SlackUserScopes.join(','));
    url.searchParams.set('client_id', SlackClientId);
    url.searchParams.set(
      'redirect_uri',
      `https://${location.host}${buildAccountUrl('/settings/integrate/slack')}`,
    );
    url.searchParams.set('state', state); // CSRF protection

    return { state, url: url.toString() };
  };

  const slackRedirectUrl = generateSlackRedirect();

  const persistSlackState = () => {
    setSlackState(slackRedirectUrl.state);
  };

  return {
    slackRedirectUrl,
    persistSlackState,
  };
};
